module.exports = __webpack_public_path__ + "img/a_01.adff9450.png";